import { render } from "./TxStatusLabel.vue?vue&type=template&id=5d2659fe&scoped=true"
import script from "./TxStatusLabel.vue?vue&type=script&lang=js"
export * from "./TxStatusLabel.vue?vue&type=script&lang=js"

import "./TxStatusLabel.vue?vue&type=style&index=0&id=5d2659fe&scoped=true&lang=scss"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2659fe"],['__file',"src/components/TxStatusLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2659fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2659fe', __exports__)) {
    console.log('reload')
    api.reload('5d2659fe', __exports__)
  }
  
  module.hot.accept("./TxStatusLabel.vue?vue&type=template&id=5d2659fe&scoped=true", () => {
    console.log('re-render')
    api.rerender('5d2659fe', render)
  })

}


export default __exports__